import createClient from 'openapi-fetch'

import { env } from '@/lib/env'

import type { paths } from './schema'

/** The header the date-of-birth challenge's short-lived pass travels in. */
export const SIGNING_SESSION_HEADER = 'X-Signing-Session'

/**
 * The client for the customer's signing link, and the only one in the app with no middleware.
 *
 * `api` in `./client.ts` attaches the bearer token and `X-Tenant-ID` to every request, and drops
 * the token on a 401. None of that belongs on a public page: the person holding the link has no
 * account and no dealership, the API resolves the tenant from the token itself, and a staff
 * member who happens to be signed in on the same phone must not have their session sent with —
 * or invalidated by — a customer's request. So this one is built from the same generated
 * contract and left bare.
 *
 * It is a second instance of the one HTTP client, not a second HTTP client.
 */
export const publicApi = createClient<paths>({
  baseUrl: env.VITE_API_URL,
  // Resolve `fetch` per call rather than at import time, so a later polyfill or test stub applies.
  fetch: (request) => globalThis.fetch(request),
})
